function isProduction(): boolean {
  return !(!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
}

const BASE_SERVER_URL = isProduction() ? 'https://flayr-api-dev.flayr.io' : 'http://localhost:8081';
const AUTH0_DOMAIN = 'login.flayr.com.au';
const AUTH0_CLIENT_ID = 'DIVYhHP5RQiV5j8DGHjE7rAkDz4s6ZPa';
const AUTH0_AUDIENCE = 'https://flayr.au.auth0.com/userinfo';
const AUTH0_REDIRECT_URL = isProduction() ? 'https://hairdressers.flayr.com.au/callback' : 'http://localhost:3000/callback';
const INSTAGRAM_CLIENT_ID = 'a7acd2cd95ba4f63804ef62c803227a2';
export { BASE_SERVER_URL, AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE, AUTH0_REDIRECT_URL, INSTAGRAM_CLIENT_ID };

